import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RootAppState } from '../../../../store/types';
import { shouldSubmitAllQuestions } from '../../../../store/settings/selectors';
import QuestionPage from '../../question/QuestionPage';
import QuestionPageSubmitOnce from '../../question/QuestionPageSubmitOnce';

type SinglePageCourseProps = {
  isSubmitAtOnce: boolean;
};

export class DefaultLayout extends Component<SinglePageCourseProps, {}> {
  render() {
    const { isSubmitAtOnce } = this.props;
    if (isSubmitAtOnce) {
      return <QuestionPageSubmitOnce {...this.props} />;
    }
    return <QuestionPage {...this.props} />;
  }
}

function mapDispatchToProps() {
  return {};
}

function mapStateToProps(state: RootAppState) {
  return {
    isSubmitAtOnce: shouldSubmitAllQuestions(state)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
